import { render, staticRenderFns } from "./PriorityList.vue?vue&type=template&id=1ef63c78"
import script from "./PriorityList.vue?vue&type=script&lang=js"
export * from "./PriorityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports